import http from "../../utils/http";
import { toast } from "../../utils/toast";

// 회사 업무 등록
export const postRoles = (data) => {
  return new Promise((resolve, reject) => {
    http
      .post("/roles", data)
      .then((res) => {
        toast.success("업무가 등록되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 회사 업무 목록 조회
export const getRoles = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/roles")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 회사 업무 조회
export const getRole = (roleIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/roles/${roleIdx}`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 전체 권한 목록
export const getRolesPermissions = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/roles/permissions")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 회사 업무 수정
export const updateRoles = (roleIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/roles/${roleIdx}`, body)
      .then((res) => {
        toast.success("업무가 수정되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 회사 업무 삭제
export const deleteRoles = (roleIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/roles/${roleIdx}`)
      .then((res) => {
        toast.success("업무가 삭제되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 업무 배정 가능한 직원 리스트
export const getRolesIdleEmployees = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/roles/idleEmployees")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 직원 업무 배정하기
export const postRolesEmployees = (roleIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .post(`/roles/${roleIdx}/employees`, body)
      .then((res) => {
        toast.success("업무가 배정되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 업무 배정 직원 조회
export const getRolesEmployees = (roleIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/roles/${roleIdx}/employees`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 업무 배정 직원 해제
export const deleteRolesEmployees = (roleIdx, roleEmployeeIdx) => {
  return new Promise((resolve, reject) => {
    http
      .delete(`/roles/${roleIdx}/employees/${roleEmployeeIdx}`)
      .then((res) => {
        toast.success("업무 배정 취소되었습니다.");
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// -------------------------- 외부담당자 --------------------------------

// 배정 가능한 담당 회사 목록 조회
export const getCompainesManagers = (type) => {
  return new Promise((resolve, reject) => {
    http
      .get("/companies/managers", { params: { type } })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 담당 회사 및 담당 직원조회
export const getCompainesMyManagers = () => {
  return new Promise((resolve, reject) => {
    http
      .get("/companies/myManagers")
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 담당회사 및 직원 변경
export const modifyCompainesMyManagers = (companyIdx, body) => {
  return new Promise((resolve, reject) => {
    http
      .put(`/companies/${companyIdx}/managers`, body)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// 담당 회사직원 조회
export const getManagerCompanyEmployees = (managerCompanyIdx) => {
  return new Promise((resolve, reject) => {
    http
      .get(`/companies/managers/${managerCompanyIdx}/employees`)
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
